import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  padding: 0 ", "rem;\n  background-color: ", ";\n  font-size: ", ";\n  top: ", ";\n  transform: translateY(-50%);\n  font-family: ", ";\n  transition: all 0.3s ease, color 0s;\n  color: rgba(44, 44, 44, 0.3);\n  pointer-events: none;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Label = styled.label(_templateObject(), function (props) {
  return props.active ? "0.5rem" : "1rem";
}, function (props) {
  return props.active ? 0.5 : 0;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.active ? props.theme.input.labelFontSize : "18px";
}, function (props) {
  return props.active ? 0 : "50%";
}, function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject2(), function (props) {
  return props.active ? props.theme.input.labelFontSize : "13px";
}));